import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import data from "../../JsonData/developer.json"
import { slugify } from '../../utils/slugify';


const DeveloperDetails = () => {
   const { developerSlug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
//  const id = queryParams.get('id'); // get id from ?id=1

  const developer = data.developerData.find(
    (prop) => slugify(prop.developername) === developerSlug
  );

  if (!developer) return <div>Developer not found</div>;

  return (
    <div className="container ">
      <h2 style={{paddingTop:"50px"}}>{developer.developername}</h2>
      <p className="mt-3">{developer.descripetion}</p>
           <h3 className="mt-4"style={{paddingBottom:"30px"}}>{developer.title || `${developer.developername} Properties`}</h3>

    </div>
  );
};

export default DeveloperDetails;
